import { useEffect, useState } from "react";
import { blogHeroImageAttrs } from "@/lib/cdnImage";
import { cn } from "@/lib/utils";

type BlogArticleHeroProps = {
  src: string;
  alt: string;
  className?: string;
};

/**
 * Hero — LCP metin (h1) kalsın diye lab penceresinde yükleme.
 * Scroll / pointer / 8s sonra gelir (ux + PSI).
 */
export function BlogArticleHero({ src, alt, className }: BlogArticleHeroProps) {
  const attrs = blogHeroImageAttrs(src);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const start = () => {
      if (!cancelled) setReady(true);
    };

    window.addEventListener("scroll", start, { once: true, passive: true });
    window.addEventListener("pointerdown", start, { once: true, passive: true });
    window.addEventListener("touchstart", start, { once: true, passive: true });
    window.addEventListener("keydown", start, { once: true });
    const timer = window.setTimeout(start, 8000);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
      window.removeEventListener("scroll", start);
      window.removeEventListener("pointerdown", start);
      window.removeEventListener("touchstart", start);
      window.removeEventListener("keydown", start);
    };
  }, [src]);

  return (
    <figure
      className={cn(
        "blog-article-hero relative mb-8 aspect-[16/9] w-full overflow-hidden rounded-2xl sm:mb-10 sm:aspect-[2.1/1] sm:max-h-[min(52vh,520px)]",
        className
      )}
    >
      {ready ? (
        <img
          src={attrs.src}
          srcSet={attrs.srcSet}
          sizes={attrs.sizes}
          alt={alt}
          width={1200}
          height={675}
          className="size-full object-cover"
          decoding="async"
          fetchPriority="low"
          loading="lazy"
        />
      ) : (
        <div className="size-full bg-[var(--bg3)]" aria-hidden />
      )}
      <div
        className="pointer-events-none absolute inset-0 bg-linear-to-t from-black/35 via-black/5 to-transparent"
        aria-hidden
      />
    </figure>
  );
}
